import Item from "./orderItemType";

export enum OrderStatus {
  CREATED = 1,
  SENT_TO_RESTAURANT = 2,
  PREPARING = 3,
  PREPARED = 4,
  PICKEDUP = 5,
  CANCELLED = 6,
  COMPLETED = 7,
}

export enum DriverOrderStatus {
  PENDING = 0,
  ACCEPTED_BY_DRIVER = 1,
  PICKEDUP_BY_DRIVER = 2,
  DELIVERED_BY_DRIVER = 3,
  REJECTED = 4,
}

type DeliverBy = {
  id: number;
  first_name: string;
  last_name: string;
  mobile: string;
};

type Order = {
  id: number;
  isWaiting: boolean;
  isReady: boolean;
  isPreparing: boolean;
  refused: boolean;
  orderer: string;
  deliverBy: DeliverBy | null;
  orderDate: string;
  timeToPrepare: string;
  price: number;
  items: Item[];
  payMethod: string;
  isDelivery: boolean;
  isPickUp: boolean;
  isAtRestaurant: boolean;
  orderNotes: string;
  estimatedTime: string | null;
  status: OrderStatus;
  driverStatus: DriverOrderStatus;
  deliveryPrice: number;
  address: string;
  ordererMobile: string | null;
  // Kitchen ticket. prepareBy is an ISO timestamp (order/start + prep duration).
  // subtotalDiscount is the items-only promotion amount, excluding delivery.
  // isNewCustomer is true when this is the customer's first non-cancelled order here.
  prepareBy?: string | null;
  subtotalDiscount?: number;
  isNewCustomer?: boolean;
};

export default Order;
